'use strict';

/* globals Modernizr */

const _ = require('lodash');

const SignupFormController = function (
  $anchorScroll, $http, $rootScope, $scope, $stateParams, $timeout, AnalyticsService, sbAuth, IdentityService, IntercomService, plansRequest, RoutingUtil, SocialLoginService, StripeCheckout
) {

  const vm = this;
  const NORMAL_TEXT = 'Get started with your free trial';
  const LOADING_TEXT = 'Loading...';
  vm.ASSETS_DOMAIN = $rootScope.CONST.assets_domain;
  vm.badEmailText = 'Invalid username';
  vm.badPasswordText = 'Invalid password';
  vm.buttonText = NORMAL_TEXT;
  vm.cloudServicesAgreementUrl = $rootScope.CONST.cloud_services_agreement_url;
  vm.error = '';
  vm.inputs = ['firstName', 'lastName', 'organization', 'email', 'password'];
  vm.isTouch = typeof Modernizr !== 'undefined' && Modernizr.touch;
  vm.menuActive = false;
  vm.showVerificationSent = false;
  vm.spinnerMessage = 'Creating Account';
  vm.text = 'Email Address not available';

  // industry selector
  vm.industrySelectorOptions = {
    constructionProfessional: 'Construction Professional',
    droneServiceProvider: 'Drone Service Provider',
    recreationalPilot: 'Recreational Pilot',
    other: 'Other'
  };

  vm.industrySelectorValue = null;
  vm.customIndustrySelector = null;

  vm.controller = 'SignupFormController';

  vm.data = {
    firstName: '',
    lastName: '',
    password: '',
    email: '',
    organization: '',
    domain: '', // if available will be used for the custom domain
    plan_id: '', // if available will be used to assign a particular plan
    stripe_object: {}, // if available will be used to assign a particular plan
    uav: '',
    coupon: '',
    rememberme: false
  };

  vm.chargebee = null;

  plansRequest
    .then((payload) => {
      const data = payload.data;
      // Don't allow passage of Plan in signup route anymore
      // vm.chargebee = _.find(data.data.list, (item) => {

      //   return item.plan.id === $stateParams.plan_id;
      // });

      // TODO: When forcing subscriptions - use this
      if (!vm.chargebee) {
        // Fallback to designated default plan
        vm.chargebee = _.find(data.data.list, (item) => {

          return item.plan.id === 'Skycatch_Pro_M';
        });
      }
    });

  const handler = StripeCheckout.configure({
    description: 'Capture, Interpret, Act',
    panelLabel: 'Start Mapping',
    shippingAddress: false,
    billingAddress: false,
    allowRememberMe: false,
    token: (token, args) => {}
  });

  vm.login = () => {

    vm.buttonText = LOADING_TEXT;

    const onError = (res) => {

      vm.buttonText = NORMAL_TEXT;
      vm.error = res.data.error;
    };

    sbAuth.authenticate(vm.data, null, onError);
  };

  vm.googleSignup = () => {

    vm.buttonText = LOADING_TEXT;
    const data = {};
    // Pass the plan from the URL. This DOES NOT use the `chargebee` object
    // (see `doCheckout`)
    if ($stateParams.plan_id) {
      data.plan_id = $stateParams.plan_id;
    }

    SocialLoginService.googleAuth(data)
      .catch(() => {

        vm.buttonText = NORMAL_TEXT;
        vm.error = vm.text = SocialLoginService.errorMessage;
      })
      .then((result) => {

        if (!result) { // Login was cancelled
          vm.buttonText = NORMAL_TEXT;
          $scope.$apply();
        }
      });
  };

  vm.fbSignup = () => {

    vm.buttonText = LOADING_TEXT;
    const data = {};
    // Pass the plan from the URL. This DOES NOT use the `chargebee` object
    // (see `doCheckout`)
    if ($stateParams.plan_id) {
      data.plan_id = $stateParams.plan_id;
    }

    SocialLoginService.facebookAuth(data)
      .catch(() => {

        vm.buttonText = NORMAL_TEXT;
        vm.error = vm.text = SocialLoginService.errorMessage;
      })
      .then((result) => {

        if(!result) { // Login was cancelled
          vm.buttonText = NORMAL_TEXT;
          $scope.$apply();
        }
      });
  };

  vm.signup = () => {

    const onError = (res) => {

      vm.showSpinner = false;
      vm.error = res.data.error;
    };

    const onSuccess = (res) => {

      vm.data.token = res.token;
      vm.login();
    };

    vm.showSpinner = true;
    _doSignup(vm.data, onSuccess, onError);
  };


  const _doSignup = (data, successFn, errorFn) => {

    const url = IdentityService.getApiUri() + 'users/signup';

    $anchorScroll('signup-form-container');

    const httpConfig = {
      url: url,
      method: 'POST',
      skipAuthorization: true,
      data: data
    };

    return $http(httpConfig)
      .then((payload) => {

        const promiseToLogin = new Promise((resolve, reject) => {

          let expired = false;
          $timeout(() => {

            expired = true;
            reject('timeout');
          }, 10000);

          return AnalyticsService.track('[CORE] Sign Up Success', 'Sign Up Success', {
            email: vm.data.email,
            industry: vm.industrySelectorValue === 'other' ? vm.customIndustrySelector : vm.industrySelectorOptions[vm.industrySelectorValue]
          })
            .then(AnalyticsService.page.bind(vm, {
              title: 'Thank you!',
              path: '/signup/thankyou/',
              url: 'https://app.skycatch.com/signup/thankyou/'
            }))
            .then((data) => {

              if (!expired) {
                resolve(data);
              }
            });
        });

        if (successFn) {
          promiseToLogin
            .then(() => {

              console.info('Sign Up events sent.')
              successFn(payload);
            })
            .catch((err) => {

              console.warn('Sign Up Tracking Error', err)
              successFn(payload);
            });
        }
      })
      .catch((payload, status) => {

        payload.errorCode = status;
        const message = payload.error.friendlyMessage;

        AnalyticsService.track('[CORE] Sign Up', 'Sign Up Fail', {
          email: vm.data.email
        });

        console.error('auth:error: ' + message, payload);

        if (errorFn) {
          errorFn(payload);
        }
      });
  };

  vm.doCheckout = (options) => {

    options = options || {};

    RoutingUtil.setDestinationChangeTopLocation(!!options.redirectParent);

    AnalyticsService.track('[CORE] Sign Up Try', 'Sign Up Try', {
      email: vm.data.email
    });

    // temporarly disable the stripe checkout
    const hardware = vm.chargebee.plan.meta_data ? vm.chargebee.plan.meta_data.hardware : false;
    if (vm.chargebee && hardware) {
      handler.open({
        name: vm.chargebee.plan.name,
        email: vm.data.email,
        // description: vm.chargebee.plan.description,
        amount: vm.chargebee.plan.setup_cost ? vm.chargebee.plan.setup_cost : vm.chargebee.plan.price,
        shippingAddress: Boolean(hardware),
        billingAddress: Boolean(hardware)
      })
        .then((result) => {

          const token = result[0];
          vm.data.stripe_object = token;
          vm.data.plan_id = vm.chargebee.plan.id;
          vm.signup();
        }, () => {

          console.log('closed');
        });
    }
    else {
      vm.data.plan_id = vm.chargebee.plan.id;
      vm.signup();
    }
  };

  if ($stateParams) {
    Object.keys(vm.data).forEach((key) => {

      if ($stateParams[key]) {
        vm.data[key] = $stateParams[key];
      }
    });
  }

  vm.openChat = () => {

    IntercomService.show();
  };

  AnalyticsService.track('[CORE] Sign Up', 'Sign Up Form View', {});

  vm.toggleMenu = () => {

    vm.menuActive = !vm.menuActive;
  };
};

module.exports = SignupFormController;



// WEBPACK FOOTER //
// ./src/app/login/signupForm/SignupFormController.js